import React from 'react';

import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { ExploDashboardContainer } from '~/packages/explo/ui/ExploDashboardContainer';

// Exports
type PortfolioStratsContainerProps = {
  creditFacilityId: string;
};
export const PortfolioFacilitiesStratsContainer = ({
  creditFacilityId,
}: PortfolioStratsContainerProps) => {
  const { user } = useUserAuthOrThrow();

  return (
    <ExploDashboardContainer
      organizationId={user.organization.id}
      creditFacilityId={creditFacilityId}
      exploPlacement="lenderFacilitiesTab"
    />
  );
};
